<template>
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col v-if="validateLoad==true" id="base" md="12" style="height: 100%;" class="my-0 py-0" >
            <v-row justify="center" align="center">
                <v-col calign-self="center" cols="auto">
                    <v-row justify="center" >
                        <v-progress-circular
                        :size="70"
                        :width="7"
                        :color="$store.state.colors.primary"
                        indeterminate
                        ></v-progress-circular>                        
                    </v-row> 
                </v-col>
            </v-row>
        </v-col>         
        <v-col v-else id="base" md="12" class="pb-0 mb-0" >
            <v-row justify="start" style="font-size: 23px" class="RestoRegular pl-4">
                Mis pedidos
            </v-row>
            <v-row justify="center" align="start" style="width: 95%; margin: 0 auto">
                <v-col>
                    <v-row v-for="(order, index) in orders" :key="index" style="background-color: #E6E6E6; border-radius: 5px" class="mt-2">
                        <v-col align-self="center" cols="auto">
                            <v-img v-if="order.metodo_entrega == 'Entrega a domicilio'" src="@/assets/resources/user/casa.svg" max-width="25px"></v-img>
                            <v-img v-else src="@/assets/resources/user/restaurante.svg" max-width="25px"></v-img>
                        </v-col>
                        <v-col align-self="center" style="font-size: 12px" class="RestoRegular">
                            <v-row class="RestoBold" style="font-size: 13px">
                               PEDIDO {{order.estatus}}
                            </v-row>
                            <v-row>
                                {{order.fecha_alta.substr(0,10)}}
                            </v-row>
                            <v-row v-if="order.metodo_entrega == 'Entrega a domicilio'">
                                {{order.calle}} #{{order.num_exterior}}, {{order.colonia}}
                            </v-row>
                            <v-row v-else>
                                {{order.calle_suc}} {{order.ciudad_suc}}, #{{order.num_exterior_suc}}
                            </v-row>
                            <v-row>
                                {{order.metodo_entrega}}
                            </v-row>
                        </v-col>
                        <v-col align-self="center" cols="auto">
                            <a @click="goTo(index); $router.push({ name: 'orderDetails', params: {id: order.id}});" style="font-size: 14px" class="RestoBold a" :style="{ 'color': $store.state.colors.primary }">
                                Detalles
                            </a>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>


<script>
export default {
    data() {
        return {
            orders:[],
            idOrder:null,
            validateLoad:true,
        }
    },
    created() {
        // console.log(localStorage.getItem("id_cliente"));
        this.$store.dispatch("GET", {url: 'pedidos_cli/' + localStorage.getItem("id_cliente"), headers: {Authorization: localStorage.getItem("token")}})
            .then(response => {
                console.log(response);
                this.orders = response.data;
                // console.log(this.orders);
                this.validateLoad=false;
            })
            .catch(error => {
                console.log("Error: " + error);
            }); 
    },
    methods: {
        goTo(index){
            this.idOrder=this.orders[index].id;
            // console.log(this.idOrder);
        }
    }
}
</script>

<style scoped>
.a:hover 
{ 
  background-color:  #E6E6E6;
} 
</style>